module.exports = __webpack_public_path__ + "img/62.030783a1.jpg";